import { ChangeDetectionStrategy, Component } from '@angular/core';

// Tiny inline chip rendered next to the BDF status pill when the job was
// generated with the high-resolution mesh option. Lives as its own component
// so the badge looks identical in every modal that hosts it — styling stays
// scoped to this component's host element regardless of the caller's
// encapsulation mode.
@Component({
  selector: 'app-bdf-highres-badge',
  template: `High res`,
  host: {
    role: 'note',
    'aria-label': 'Generated with high-resolution mesh',
    title: 'Generated with high-resolution mesh',
  },
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      height: 1.25rem;
      padding: 0 0.5rem;
      border-radius: 999px;
      font-size: 0.6875rem;
      font-weight: 600;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      white-space: nowrap;
      // Mirror the --bdf-badge-* family (idle/queued/error). Token-only
      // fallbacks resolve to the light-theme amber palette — amber-900 on
      // amber-100 is 10.4:1 contrast (WCAG AAA for small text).
      background: var(--bdf-badge-highres-bg, #fef3c7);
      color: var(--bdf-badge-highres-fg, #78350f);
      border: 1px solid var(--bdf-badge-highres-border, #fcd34d);
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdfHighresBadgeComponent {}
